import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import URLS from "redux/urls";
import request from "redux/utils/request";

export const fetchAllAspirasi = createAsyncThunk(
  "Aspirasi/fetchAllAspirasi",
  async (params, { rejectWithValue }) => {
    try {
      const response = await request("get", URLS.ASPIRASI, params);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const addAspirasi = createAsyncThunk(
  "Aspirasi/addAspirasi",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request("post", URLS.ASPIRASI, payload);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const updateAspirasi = createAsyncThunk(
  "Aspirasi/updateAspirasi",
  async (payload, { rejectWithValue }) => {
    try {
      const response = await request(
        "patch",
        `${URLS.ASPIRASI}/${payload.id}`,
        payload
      );
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);
export const fetchOneAspirasi = createAsyncThunk(
  "Aspirasi/fetchOneAspirasi",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("get", `${URLS.ASPIRASI}/${id}`);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

export const deleteAspirasi = createAsyncThunk(
  "Aspirasi/deleteAspirasi",
  async (id, { rejectWithValue }) => {
    try {
      const response = await request("delete", `${URLS.ASPIRASI}/${id}`);
      return response.data;
    } catch (error) {
      return rejectWithValue(error);
    }
  }
);

const initialState = {
  loading: {
    query: false,
    mutation: false,
  },
  filter: {
    q: "",
  },
  list: [],
  count: {},
  selected: {},
  selectedRows: [],
};

const loadingReducer = (fieldName, status) => (state) => {
  state.loading[fieldName] = status;
};

const startLoadingQuery = loadingReducer("query", true);
const stopLoadingQuery = loadingReducer("query", false);
const startLoadingMutation = loadingReducer("mutation", true);
const stopLoadingMutation = loadingReducer("mutation", false);

export const AspirasiSlice = createSlice({
  name: "Aspirasi",
  initialState,
  reducers: {
    setAppliedSearchText: (state, action) => {
      state.filter.q = action.payload;
    },
    setSelectedRows: (state, action) => {
      state.selectedRows = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllAspirasi.pending, startLoadingQuery)
      .addCase(fetchAllAspirasi.fulfilled, (state, action) => {
        state.list = action.payload;
        state.loading.query = false;
      })
      .addCase(fetchAllAspirasi.rejected, stopLoadingQuery);
    builder
      .addCase(fetchOneAspirasi.pending, startLoadingQuery)
      .addCase(fetchOneAspirasi.rejected, stopLoadingQuery)
      .addCase(fetchOneAspirasi.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(updateAspirasi.pending, startLoadingQuery)
      .addCase(updateAspirasi.rejected, stopLoadingQuery)
      .addCase(updateAspirasi.fulfilled, (state, action) => {
        state.loading.query = false;
        state.selected = action.payload;
      });
    builder
      .addCase(deleteAspirasi.pending, startLoadingMutation)
      .addCase(deleteAspirasi.fulfilled, stopLoadingMutation)
      .addCase(deleteAspirasi.rejected, stopLoadingMutation);
  },
});

export const { setSelectedRows, setAppliedSearchText } = AspirasiSlice.actions;

export default AspirasiSlice.reducer;
